import React from 'react';
import { Checkbox } from 'semantic-ui-react';

import { BondInsuranceForGetBondInsurancesResponseDTO } from '../../../dtos/bond-insurance-list/get-bond-insurances-response.dto';

type Props = {
  bondInsurance: BondInsuranceForGetBondInsurancesResponseDTO;
  standaloneChargesEnabled?: boolean;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const canCreateSetupCharge = (
  bondInsurance?: BondInsuranceForGetBondInsurancesResponseDTO
) => {
  const estate = bondInsurance?.estate as any;
  return Boolean(
    estate?.standaloneChargesEnabled ?? estate?.standalone_charges_enabled ?? false
  );
};

const SetupChargeShortcut: React.FC<Props> = ({
  bondInsurance,
  standaloneChargesEnabled,
  checked,
  onChange
}) => {
  const isEnabled =
    typeof standaloneChargesEnabled === 'boolean'
      ? standaloneChargesEnabled
      : canCreateSetupCharge(bondInsurance);
  if (!isEnabled) return null;
  const checkboxId = `create-setup-charge-shortcut-${bondInsurance.id}`;

  return (
    <section style={{ marginTop: 20 }}>
      <h3
        style={{
          color: '#2B313C',
          fontSize: 16,
          borderBottom: '1px solid #DDDDDD',
          paddingBottom: 10,
          margin: '0 0 12px',
          textTransform: 'uppercase'
        }}
      >
        Taxa de setup
      </h3>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          border: '1px solid #DDDDDD',
          borderRadius: 8,
          padding: '10px 12px',
          cursor: 'pointer'
        }}
      >
        <Checkbox
          id={checkboxId}
          checked={checked}
          onChange={(_, data) => onChange(Boolean(data.checked))}
          aria-label="Criar cobrança de taxa de setup após a contratação"
        />
        <label
          htmlFor={checkboxId}
          style={{ display: 'block', color: '#6F747D', fontSize: 14, cursor: 'pointer' }}
        >
          <strong style={{ color: '#2B313C' }}>
            Desejo realizar uma Cobrança de Taxa de Setup ao concluir a contratação
          </strong>{' '}
          <span style={{ color: '#A7ABB2' }}>(Opcional)</span>
          <br />
          Utilizar os dados da contratação para enviar uma Cobrança de taxa de setup. Você
          será redirecionado após a confirmação.
        </label>
      </div>
    </section>
  );
};

export default SetupChargeShortcut;
